<script setup lang="ts">
import { useCallStore } from "../../../store/calls";
import { useModalStore } from "../../../store/modal";
import DefaultModalBase from "../DefaultModalBase.vue";
import {computed, ref} from "vue";

const callStore = useCallStore()
const modalStore = useModalStore()
const loading = ref(false)
const note_added = ref(false)
const disabled = computed(() => loading.value || !note.value)
const heading = computed(() =>
    note_added.value
        ? "Note added."
        : "Add a note."
)
const note = ref()
const addNote = async () => {
    loading.value = true
    await callStore.addNote(modalStore.props.id, note.value)
    loading.value = false
    note_added.value = true
}
</script>

<template>
<DefaultModalBase :heading :icon="note_added ? 'check-all' : 'paper-file'" :loading :refresh="note_added">
    <div class="call-assign-container" >
        <brand-form-textarea label="Note details." v-model="note" v-if="!note_added"/>
        <brand-button @click="addNote()" :disabled v-if="!note_added">Save note</brand-button>
        <brand-button @click="modalStore.close(note_added)" variant="secondary" v-else>Done</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>
